import Button from 'components/Buttons/Button';
import Icon from 'components/Icon/Icons';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ClipLoader } from 'react-spinners';
import Transition from 'react-transition-group/Transition';
import './SnackBar.scss';

/* Supported positions
  • topCenter
  • topLeft
  • topRight
  • bottomCenter
  • bottomLeft
  • bottomRight
  • centerLeft
  • centerRight
  • mapCenterBottom

  The component is setup to handle positions dynamically, however corresponding
  styles must be applied in SnackBar.scss for transitions to work properly.
*/

class SnackBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultStyle: {},
    };
  }

  onEnter = node => {
    node.classList.add(`snackbar__slide-enter--${this.props.position}`);
    node.style.animationFillMode = 'forwards';
    node.style.animationDuration = `${this.props.duration || 500 * 0.001}s`;
  };
  onEntered = node => {
    node.classList.remove(`snackbar__slide-enter--${this.props.position}`);
  };
  onExit = node => {
    node.classList.add(`snackbar__slide-exit--${this.props.position}`);
    node.style.animationFillMode = 'forwards';
    node.style.animationDuration = `${this.props.duration || 500 * 0.001}s`;
  };

  render() {
    const { defaultStyle } = this.state;
    const {
      children,
      classNames,
      showSpinner,
      position,
      duration,
      styles,
      inProp,
      container = document.body,
      handleClose,
    } = this.props;
    const snackBarPosition = this.props[position];
    const snackBarStyles = { ...defaultStyle, ...styles, ...snackBarPosition };

    return ReactDOM.createPortal(
      <Transition
        in={inProp}
        timeout={duration || 500}
        onEnter={this.onEnter}
        onEntered={this.onEntered}
        onExit={this.onExit}
        unmountOnExit
      >
        {() => (
          <article
            id="snackbar"
            className={classNames}
            style={{
              ...snackBarStyles,
            }}
          >
            {typeof handleClose === 'function' && (
              <Button
                handleClick={handleClose}
                className="snackbar-close-btn text-btn"
                aria-label="close modal"
              >
                <Icon>close</Icon>
              </Button>
            )}
            {showSpinner === 'before' && (
              <ClipLoader color={'none'} size={14} />
            )}
            {children}
            {showSpinner === 'after' && <ClipLoader color={'none'} size={14} />}
          </article>
        )}
      </Transition>,
      container
    );
  }
}

export default SnackBar;
